export default "__VITE_ASSET__BQh8JLsp__"